<div class ="flex flex-col m-30 mt-72 h-3/4 w-3/6 card p-20 items-center shadow-lg hover:shadow-xl">
    <div class="flex flex-row items-center justify-between w-full">
        <h1 class="text text-gray text-2xl">Roster</h1>
        <app-teamselector (newTeamSelectedEvent)="changeTeam($event)"></app-teamselector>
    </div>
    <app-playerlist class="w-full" [teamId]="selectedTeam"></app-playerlist>
</div>
